/**
 * Hearen Landing
 *
 * Première page présentée avant l'application.
 *
 * Objectif :
 * Construire la confiance avant de présenter la technologie.
 *
 * Philosophie Sebone :
 * "Je vous explique qui nous sommes."
 */

import React from "react";

const HearenLanding = () => {
  return (
    <div className="min-h-screen bg-[#0A0F1C] text-white flex items-center justify-center px-6">
      <div className="max-w-3xl text-center">

        <h1 className="text-5xl font-semibold leading-tight mb-6">
          Vous avez des acouphènes ?
          <br />
          Hearen est là pour ça.
        </h1>

        <p className="text-xl text-white/70 leading-relaxed mb-12">
          Une approche personnalisée pour vous accompagner au quotidien,
          dans le respect de votre audition et avec prudence.
        </p>

        <div className="flex justify-center gap-4">
          <button className="px-8 py-4 rounded-xl bg-white text-black font-medium hover:opacity-90 transition">
            Découvrir Hearen
          </button>

          <button className="px-8 py-4 rounded-xl border border-white/20 text-white hover:bg-white/10 transition">
            Comprendre notre approche
          </button>
        </div>

      </div>
    </div>
  );
};

export default HearenLanding;